//IMPORTART TYPES
import {
    OBTENER_MENU_ADMIN,
    OBTENER_MENU_STOCK,
    OBTENER_MENU_STOCK_ERROR,
    OBTENER_MENU_ADMIN_ERROR
} from '../../types';


export default (state , action) => {
    switch (action.type) {
        case OBTENER_MENU_STOCK :
        case OBTENER_MENU_ADMIN :    
            return {
                ...state,
                platos : action.payload.platos,
                ingredientes : action.payload.ingredientes,
                bebidas : action.payload.bebidas,
                bebidaSalon : action.payload.bebidaSalon,
                cargando : null
            }
        case  OBTENER_MENU_STOCK_ERROR : 
        case  OBTENER_MENU_ADMIN_ERROR :
            return {
                ...state,
                mensaje : action.payload,
                cargando : null
            }
        default:
            return {
                ...state
            }
    }
}